// Batch 3 sales, customers, invoices, expenses, and financial analytics UI catalogs.
export const batch3En = {
  "016e578a2ed1": "Live Alert Feed",
  "023d1181ebc6": "Low Stock",
  "035eae60290f": "Customers",
  "042c862e4467": "Try again",
  "04e24bb92c9c": "Detailed Analytics",
  "052935803586": "OPEX",
  "05882967d7f8": "Present Today",
  "06cdec0f2e09": "Expiring Items",
  "06d91444ec58": "Break-Even Chart",
  "07a02d4abd0b": "Revenue Target",
  "07b146812266": "CHANGE",
  "082bc378cd60": "Month",
  "0856945b0938": "Computing...",
  "0876797952f8": "GCash ref, Cheque #, etc.",
  "08ec4198dfb9": "Avg Order Value",
  "0930f3f8992c": "Annual",
  "09f52b85861f": "Use the payment action in Sales History to record invoice collections. Existing balances remain live in the customer ledger.",
  "0bebea9f7887": "Point of Sale",
  "0bf95aa36983": "Net:",
  "0c6c4102d4df": "Optional",
  "0e85749a6f40": "Customer",
  "0eb25859933e": "Active Employees",
  "0ef22980eccc": "Average Sale",
  "0ef7d891503a": "Break-Even",
  "0f6cc3a89ce9": "This Month",
  "0fd7db599a63": "Unit Price (",
  "10478ff84412": "Sales (Month)",
  "11dc9e195292": "Status:",
  "11f53e51785e": "Gross Profit",
  "11f6ad8ec52a": "x",
  "12748281e0f0": "Units",
  "127c03434417": "Send to Google Drive",
  "129ff4d79ddb": "All revenue metrics, at a glance.",
  "13fe19c2df86": "Find the point where revenue covers costs — or auto-calculate per species using live data.",
  "14210f551fd8": "Expected Farrowing",
  "14467753cedc": "Animals by Species",
  "145caf292855": "Due",
  "14bbc03e4044": "Accounts Payable:",
  "14fbc6d9a834": "Product Sales",
  "14fe05d831b7": "Customer Payments",
  "158f3da59275": "Weekly",
  "15c19e1d9e1e": "Net (after CAPEX)",
  "16e890a4714a": "Loading reconciled financial records…",
  "170a28a9db6d": "Period",
  "172a3d450eff": "Cash in Drawer",
  "179ac1a75869": "Select animal",
  "17ae734e917c": "Sale Price",
  "18d0a9ba06b5": "Transactions Today",
  "19130d3f1b9d": "Achievement",
  "19adf6127aec": "Invoice list, receipts, payments, refunds, and cancellations.",
  "1a16790b5c4f": "Variable Cost per Unit (",
  "1a7b7c1b33d1": "Transaction",
  "1c89b1f2aaab": "Income",
  "1c9f6939e013": "Data source: Live backend APIs",
  "1d70cc92c0d7": "Pregnant and Due Soon",
  "1d75774c0f96": "Order",
  "1dc043bb8eb5": "Money",
  "1e0b597ec3c9": "day(s)",
  "1e5ff9e500c2": "Qty",
  "1eae2e68e7a6": "Top 5 Customers",
  "1ee8fea1697e": "Out:",
  "1eea68d093d1": "Unit Price",
  "1f77e83907c4": "Choose...",
  "1fc0f8756bf3": "Livestock Analytics",
  "1ffab4400495": "Equity:",
  "20e338624cee": "Assets",
  "20fe4f42d7f8": "Last Month",
  "21808a71ead8": "Trend / Top Products",
  "21bc3ec9ecc6": "Total Customers",
  "226da5b84ad7": "Inventory Analytics",
  "22d5a3425998": "Add Animal",
  "2331907868e4": "Record payments from the Invoices tab — click \"Pay\" on any unpaid invoice. Supports cash, bank, GCash, Maya, cheque, and mixed.",
  "24345a14377f": "Today",
  "25bc96295797": "Analytics",
  "281119acb9e0": "Farm filter: Global",
  "28484e9d2642": "Animals are sold through the same invoice ledger and stay fully traceable.",
  "285420aea9e2": "Profit Trend",
  "286daeb2a843": "Sales completed through POS or invoices will appear here.",
  "29972f1aec9b": "units to sell per month",
  "2a6590d41767": "Amount Received",
  "2ab1c3e525b2": "Total Amount (",
  "2b7336c8b9c9": "Reference / receipt #",
  "2bb6b986c5d6": "active",
  "2ee750e04190": "Tip:",
  "2f711885e0a7": "Contribution / Unit",
  "300cb1a029ad": ". To improve accuracy, assign employees to specific species (Admin → Employees), and tag inventory-movements with `species_id`.",
  "304f2a6def00": "No products match. Add some in Sales & Inventory.",
  "30ad4167acea": "Remaining:",
  "30e4e2a86cc2": "Select payable",
  "317b1560fa04": "Late Employees",
  "318e2b4635fc": "Collections Summary",
  "31b956ddaa0e": "Product sales",
  "32815b0bb690": "Create Invoice",
  "32cf4b682e2b": "Executive View",
  "330450b7aa66": "Live farm data",
  "33399e1e8956": "Income versus Expenses",
  "33d7d03e71d4": "Period (YYYY-MM)",
  "3426de70a65a": "Sales Today",
  "3551f3225c61": "Break-Even Analysis",
  "35cf82f9d2a9": "Revenue",
  "35f8f37b92ae": "Invoices",
  "3609fc2d5fb5": "Current Stock",
  "36bff64e5d67": "Disposals Today",
  "3ba74080a591": "30-Day Revenue Trend",
  "3bcdd674f34e": "Send to Drive",
  "3c45b957fdc8": "Purchase Order",
  "3c8d8b817f47": "In:",
  "3deb74565196": "Type",
  "3e28eff6c2fc": "💡 Allocation:",
  "3e3d9cd36f9d": "Paid Invoices",
  "3e8248e32edf": "Price",
  "3ed8fbe89a9e": "No executive data available yet.",
  "3f66052a107e": "From",
  "4053152f0642": "total alerts",
  "42d21c02f4d3": "Disposals",
  "43dc8532f7e5": "Amount",
  "44357ae55a21": "Payments",
  "444fa32c06a7": "Expense Categories",
  "44656820495b": "Cart",
  "44d25b5d1b6d": "Items",
  "44f6af694554": "Quantity",
  "4532461123e1": "Checkout & Pay",
  "4552eaf4d115": "Sale price",
  "4651a34e4df9": "Scope",
  "46cf37e16197": "Or type walk-in name...",
  "474108de344b": "Paid invoices",
  "47cae30647fe": "Avg Sale Price",
  "47f8ae35eabf": "No receivables.",
  "49256255d0b0": "No payables.",
  "4a12196ff4e8": "Profit & Loss",
  "4ac296d5b2cc": "New Product",
  "4af592953912": "Construction (selected period)",
  "4b1f23f98e4f": "Sale Complete",
  "4b29c42c0d21": "Executive KPI Cards",
  "4c71073f929b": "active ·",
  "4d78e9f9edf0": "Cash Flow",
  "4e68dca8ab90": "This Week",
  "4e896ec2eec4": "Print Receipt",
  "4f327665da59": "Log Disposal / Allocation",
  "4fa71d634f54": "Manual Inputs",
  "4fee51fde270": "Business Name",
  "50cc12f69e8f": "Unpaid",
  "51d8604430df": "Invoice #",
  "5301648dcf6b": "Edit",
  "54376586d240": "Walk-in customer",
  "5530e706d06b": "+ Med",
  "556a420333dd": "Liabilities",
  "55edd462872a": "Supplier",
  "55f8ebc805e6": "Description",
  "560512c253ff": "No sales history",
  "5651124db206": "Sales Dashboard",
  "5674f7dce889": "Financial Analytics",
  "56e3badc4e6c": "Refresh",
  "5801dd294561": "AI Dashboard Insight",
  "597f97a60987": "Balance Sheet",
  "59ef31e37acc": "Reorder Level",
  "5a9469156270": "Top Product",
  "5ab37b321059": "Save Supplier Payment",
  "5b0f7590d06f": "Collected",
  "5b221e9c2a45": "Print",
  "5c6505ae3c86": "TOTAL",
  "5e0d7363a956": "Customer:",
  "5f5a3fc65a12": "Inventory:",
  "5f612f65fc3f": "Search products / animals",
  "5fa823f392c5": "Expected Births",
  "5fc7a471696c": "Income Mix",
  "6028a9a64574": "Cost Price",
  "60d582bbb8cd": "Expense Mix",
  "61ad50a9b918": "Target",
  "62c7fcf46e27": "Analysis",
  "63c904559993": "Performance",
  "64fbd995d3b6": "Change",
  "650fe991ac42": "Grand total",
  "6577ced3c078": "Record Payment",
  "659dba210997": "Payment Tracking",
  "67dc05bac4fb": "New Target",
  "6817176b8305": "Select customer",
  "689338b65b38": "Price per Unit (",
  "6a151d73d61b": "Total Paid",
  "6a2c211d3147": "Walk-in name",
  "6a98e192a983": "No matching products",
  "6bdb25798a64": "Farm-Wide ·",
  "6c30d2615392": "rows",
  "6d6343ca92e0": "Select a species — we'll pull live feed, medicine, payroll, and sales data to compute its real break-even automatically.",
  "6ef8f5d65e5f": "Supplier Payments",
  "6f98cfd4f8fd": "Sales Target",
  "700edaf90808": "Outstanding invoices",
  "70440046a3dc": "Notes",
  "706b2285196c": "Supplier Payment",
  "709a23220f2c": "Name",
  "717e1e93af99": "Del",
  "719ea396ad92": "Clear",
  "71fe22635ffe": "show the same metrics scoped to the current month.",
  "728298d3dbf4": "Daily",
  "728acc0ce486": "No targets yet. Click \"New Target\" to set your first monthly goal.",
  "734a57d75218": "Could not load Sales",
  "7389b3b752fa": "Animal",
  "739b6164d8f7": "Overdue Invoices",
  "748c323563fa": "Pay now",
  "75636316f9d7": "Customer Name",
  "768345f2ef09": "Run a report to see results.",
  "77064d526523": "Phone",
  "776bc10edafc": "Log Disposal",
  "77dfd2135f4d": "Cancel",
  "78c072709400": "Cashier",
  "7a20bf140d9c": "Quick Payments",
  "7aab10488c30": "Higher is better",
  "7bb2ee60f7c8": "Actual",
  "7c62a1424469": "Available",
  "7d87e329b6f5": "Credit Available",
  "7da80f376d4f": "No invoices yet.",
  "7e505191686b": "Revenue vs total cost across units sold",
  "7ed9b8236e54": "Alerts and Reminders",
  "7f8966640d8f": "Units Target",
  "7f9047479da7": "Margin:",
  "801d866beb88": "Walk-in",
  "80c37573afed": "Pay",
  "8159bd4e7e98": "Search customers...",
  "824b30eb3d6f": "sold this month",
  "8324113fd693": "Attendance Summary",
  "83a7238826ab": "Species",
  "83c81d7a5d24": "Cart is empty. Tap products to add.",
  "8434c52b54f0": "Receiver",
  "84add5b29527": "Email",
  "8598222918d3": "Select",
  "85bfb2b6f8f1": "Animal sales, product sales, invoices, receipts, customer database, payment tracking, and sales history.",
  "85c2702ad781": "Sales & Inventory",
  "865c087f16fa": "Treatments Due",
  "869bd1fe0a00": "Low Stock Items",
  "86b6e9c44c38": "Enter animal sale price",
  "878bae99dd28": "New Invoice",
  "88306943fea7": "Method",
  "8870388c7105": "Sales Desk",
  "88a006abc361": "No products yet. Add your first!",
  "88bc3fe3dadd": "Reports",
  "88f98b3800dc": "Feed Consumption Trend",
  "8a45d339a638": "Credit",
  "8ab4a4daf337": "No supplier payments.",
  "8bebc63cc939": "Net Profit",
  "8c34947365c3": "No customer sales yet",
  "8d437dbf95ab": "Expenses",
  "8da7a1d95a5f": "Tasks & Reminders",
  "8dce170de238": "Value",
  "8e104572372b": "Accounts Payable",
  "8e5903a8e4db": "Calculate",
  "8faf93a978fd": "CAPEX (Month)",
  "90eef613042c": "Balance",
  "9150bcc33369": "Animal Sales",
  "917625318331": "units",
  "927273a84696": "Invoices Month",
  "92cd1375d5cf": "Use Actual",
  "92f24dfdc1ba": "Spoilage Value",
  "93206d9bd672": "No disposals logged yet.",
  "9387477796af": "Live livestock",
  "93b2cc26caff": "No customers yet. Add your first!",
  "949bac1aa62e": "Month sales",
  "94efd3f5de9c": "Farm Overview",
  "9644346d2301": "Sales Trend",
  "96d034d0e103": "Save Disposal",
  "97f7359ed801": "Subtotal",
  "985cefcf2186": "Mortality Trend",
  "98635e8c6343": "Loading sales workspace...",
  "98e5ef062b2a": "Download PDF",
  "9988442239f1": "Loading executive dashboard...",
  "998955fd9442": "Retail Net Profit",
  "9a4e89db46e7": "of farm · Period",
  "9b00e5c1e298": "Auto Per-Species Profitability",
  "9be70f66f8dd": "Tax",
  "9cc8dedc2b90": "Feed and Medicine Stock",
  "9e9477eabd86": "Absent Today",
  "9f5cd8a2e880": "Retry",
  "a00475b4d631": "Receipt Preview",
  "a08e11119aef": "Excel",
  "a0db8e68b834": "Expense",
  "a16f1a3eb266": "Cash & Bank:",
  "a1b26b4530ec": "Profit Goal (optional)",
  "a1b308ec704a": "Due Date",
  "a1fdaa6b2a84": "Operations",
  "a25ca5d39a61": "Today sales",
  "a2db98ef530b": "Inventory Valuation",
  "a2e5076fdbe4": "Best Day of Week",
  "a345f2e5b6e6": "AJ'S FARM · COMMAND CENTER",
  "a3c686e711e4": "Category",
  "a438f6b92752": "Variable Cost / Unit",
  "a4a52407a5c6": "Download / Print PDF",
  "a666b9243f26": "Report Type",
  "a72ca256dc49": "Statement",
  "a965c5d733ce": "Already paid:",
  "a9f3f5b0b784": "Actual Revenue (Month)",
  "aa389b318ef8": "Current period:",
  "ad68e79c9015": "Payment Methods",
  "ae1899ecfd17": "Subcategory",
  "ae61346ab23e": "Choose species...",
  "ae65324b857d": "Farm Operations",
  "ae79ea1e9c63": "To",
  "af5c4843442e": "Overdue Tasks",
  "b04ba49f8486": "Loading...",
  "b0730eec432f": "No customer payments.",
  "b0bc4d15fe08": "Farm-wide",
  "b0dd615cbbdc": "Contacts",
  "b1a3b1aee034": "Units sold",
  "b1ffeaea78c8": "Good morning,",
  "b25928c69902": "Total",
  "b28a7d69c448": "Disposal / Allocation Log",
  "b298bc6a9e73": "Vaccinations Due",
  "b32f279e548b": "each",
  "b524936d7aa1": "Discount",
  "b5674a023931": "Location filter:",
  "b58398a70de3": "Farm at a glance",
  "b692be478a94": "No customer records",
  "b6c600062323": "Top customers",
  "b8bcab1c909b": "Over Credit Limit",
  "b93abe4c560c": "Sales Analytics",
  "b956fe74ee95": "Inventory Movement Summary",
  "baca91664986": "Live inventory",
  "bae7d5be7082": "Status",
  "bba03798749d": "Partial Invoices",
  "bbfa773e5a63": "Close",
  "bcecf4562f17": "Stock",
  "bd7d7de86af6": "Market-Ready Animals",
  "bd91f0161b70": "Financial",
  "be6ffb598e6a": "Select eligible animal",
  "bfa0df1d1c50": "Manage →",
  "bfa4d6fa106b": "Animal Sale",
  "bfe0a80d77d5": "Track credit limits, outstanding balances, and account statements.",
  "c0b84858c247": "Cashier Leaderboard",
  "c1934178ea75": "Save Scenario",
  "c201cc5e25b6": "Statement —",
  "c2f1302a0a50": "Credit Limit",
  "c2f9c4fd53fb": "Credit Limit (",
  "c3e815afba60": "invoices",
  "c677df573f74": "Add Animal Sale",
  "c7b6a95036d3": "MoM Growth",
  "c89dd33c646c": "Ref",
  "c8e4fecc6486": "Add products or animals to create an invoice.",
  "c92c0c39c1e8": "Add Customer",
  "cad804aedb53": "Accounts Receivable",
  "cae905d7914f": "Sales History",
  "cba7e62fc003": "Name, SKU, tag, species...",
  "cce0c146af66": "Expiring Medicine",
  "cd24f58f2ae4": "Notes / Items",
  "ce85fb7cc24b": "Animals by Status",
  "cf558941e04e": "Debit",
  "cfc68d1ba331": "New Transaction",
  "cfc77c0c1b1f": "Recent Stock Movements",
  "cffa50a32cb1": "and",
  "d0edfb6e8c55": "Sales",
  "d145bb830936": "Name *",
  "d1f0809a0d18": "Op. Profit",
  "d2faabf68a9f": "Total Billed",
  "d31edb7b8a94": "Monthly",
  "d3ac55072811": "Sales Targets",
  "d3d362b505e9": "Name...",
  "d45987441aa0": "Payroll",
  "d481afbb2502": "Income vs Expense Trend",
  "d48f53aaa4da": "No payments yet",
  "d558761bed9b": "Search by product name or SKU.",
  "d59192b9c8f2": "SKU",
  "d5a5e547a728": "Total Collected",
  "d613d88cb2d8": "PDF",
  "d622ac995de6": "Products · Invoices · Payments · Disposals — all in one place.",
  "d63af7f176b1": "Fixed Cost Share",
  "d7020f448aaf": "Remarks",
  "d70f93df5e8f": "Address",
  "d87f47b47e4d": "Dashboard",
  "d8e7170f94e7": "Total:",
  "d96f52b84799": "Inventory Value",
  "da33e1b7e0c4": "Construction",
  "db1c784524e1": "Reference",
  "dc9d4584a554": "Paid",
  "dd3b86d1ef21": "Product",
  "dda2313a7779": "Accounts Receivable:",
  "de556948132e": "Saved Scenarios",
  "debd497b31c2": "Outstanding A/R",
  "e17c8ad0dc2e": "Refund",
  "e2234e0631a8": "· stock",
  "e26102ea8e0e": "Amount to Pay",
  "e300af6aa1ab": "Active Customers",
  "e32ed0097417": "Here's what's happening on your farm today.",
  "e34523b36c1d": "Loading executive analytics...",
  "e38c3c26615c": "Invoices Today",
  "e3ea0776251e": "Fast checkout — pick products, take payment, print receipt.",
  "e3f5f6946da2": "Search product or SKU...",
  "e46c6a339995": "Receiver / Customer",
  "e6d551b7005d": "Customer Database",
  "e7122e2a7891": "CAPEX",
  "e765a0a52295": "Per Species",
  "e77284395aa6": "/sales-dashboard",
  "e7fee63fe608": "Category Mix (Month)",
  "e83c8a8ffdc9": "Revenue kept per unit after variable cost",
  "eb6360a6e8b7": "Attendance and Payroll",
  "eb9a4bc1c0c1": "Date",
  "ec8a638c20f0": "Cart (",
  "efc007a393f6": "Save",
  "f07ca04bdec7": "Cart is empty",
  "f1a20bd22739": "Create customers from the Customers page to track balances here.",
  "f1fbb2b43dca": "Preview",
  "f219cc0614ae": "Reason",
  "f2302c88a11a": "Invoice Only",
  "f292b8081d8b": "Average order value",
  "f2a3f161d5b6": "No sales yet",
  "f383f6a23c87": "Payment Method",
  "f41107c4fcd2": "All Targets",
  "f52767eee809": "Last updated:",
  "f5f032b11074": "/overview",
  "f6638aaa02f9": "- due",
  "f67c40299562": "Animal sales",
  "f6b935ab3371": "Unit",
  "f6fdbe48dc54": "Delete",
  "f794b6c6d153": "No transactions yet.",
  "f7af89907cdc": "Break-Even Revenue",
  "f7c40075b47e": "Contribution Margin",
  "f81e6e6edd64": "Unpaid Invoices",
  "f834ab20b880": "Top 10 Products (Revenue this Month)",
  "f871a067ec7e": "10kg pork @ ₱250, 5kg tilapia @ ₱180...",
  "f8ee57ec8645": "Outstanding",
  "f9c30b15af01": "Break-Even Units",
  "f9e6fe6b07f8": "Weight Trend",
  "f9f38818c406": "Invoice",
  "fa3cf2ad51e0": "Sell",
  "fccd53375cbe": "Payroll Payable:",
  "fe0a091fdbfb": "Products",
  "fe5505baf6c5": "Fixed Costs / mo (",
  "fef503a9816e": "Payments Recorded",
  "ff1928e5d29b": "Feed"
};

export const batch3Tl = {
  "016e578a2ed1": "Live na Daloy ng Babala",
  "023d1181ebc6": "Mababang Stock",
  "035eae60290f": "Mga Customer",
  "042c862e4467": "Subukan muli",
  "04e24bb92c9c": "Detalyadong Analytics",
  "052935803586": "OPEX",
  "05882967d7f8": "Present Ngayon",
  "06cdec0f2e09": "Mga Item na Malapit Mag-expire",
  "06d91444ec58": "Chart ng Break-Even",
  "07a02d4abd0b": "Target na Revenue",
  "07b146812266": "CHANGE",
  "082bc378cd60": "Buwan",
  "0856945b0938": "Kinakalkula...",
  "0876797952f8": "GCash ref, Cheque #, etc.",
  "08ec4198dfb9": "Karaniwang Halaga ng Order",
  "0930f3f8992c": "Taunan",
  "09f52b85861f": "Use the payment action in Mga Benta History to record invoice collections. Existing balances remain live in the customer ledger.",
  "0bebea9f7887": "Point of Benta",
  "0bf95aa36983": "Net:",
  "0c6c4102d4df": "Opsyonal",
  "0e85749a6f40": "Customer",
  "0eb25859933e": "Mga Aktibong Empleyado",
  "0ef22980eccc": "Karaniwang Benta",
  "0ef7d891503a": "Break-Even",
  "0f6cc3a89ce9": "Ngayong Buwan",
  "0fd7db599a63": "Unit Price (",
  "10478ff84412": "Mga Benta (Month)",
  "11dc9e195292": "Status:",
  "11f53e51785e": "Gross Profit",
  "11f6ad8ec52a": "x",
  "12748281e0f0": "Mga Unit",
  "127c03434417": "Ipadala sa Google Drive",
  "129ff4d79ddb": "Lahat ng revenue metric sa isang tingin.",
  "13fe19c2df86": "Hanapin ang puntong natatakpan ng revenue ang gastos, o awtomatikong kalkulahin bawat species gamit ang live data.",
  "14210f551fd8": "Inaasahang Farrowing",
  "14467753cedc": "Mga Hayop Ayon sa Species",
  "145caf292855": "Due",
  "14bbc03e4044": "Accounts Payable:",
  "14fbc6d9a834": "Product Mga Benta",
  "14fe05d831b7": "Mga Bayad ng Customer",
  "158f3da59275": "Lingguhan",
  "15c19e1d9e1e": "Net (pagkatapos ng CAPEX)",
  "16e890a4714a": "Naglo-load reconciled financial records…",
  "170a28a9db6d": "Panahon",
  "172a3d450eff": "Cash sa Drawer",
  "179ac1a75869": "Pumili animal",
  "17ae734e917c": "Benta Price",
  "18d0a9ba06b5": "Mga Transaksyon Ngayon",
  "19130d3f1b9d": "Nakamit",
  "19adf6127aec": "Listahan ng invoice, resibo, bayad, refund, at cancellation.",
  "1a16790b5c4f": "Variable Cost per Unit (",
  "1a7b7c1b33d1": "Transaksyon",
  "1c89b1f2aaab": "Income",
  "1c9f6939e013": "Pinagmulan ng datos: Live backend APIs",
  "1d70cc92c0d7": "Buntis at Malapit Nang Manganak",
  "1d75774c0f96": "Order",
  "1dc043bb8eb5": "Money",
  "1e0b597ec3c9": "day(s)",
  "1e5ff9e500c2": "Qty",
  "1eae2e68e7a6": "Top 5 Mga Customer",
  "1ee8fea1697e": "Out:",
  "1eea68d093d1": "Presyo Bawat Unit",
  "1f77e83907c4": "Pumili...",
  "1fc0f8756bf3": "Livestock Analytics",
  "1ffab4400495": "Equity:",
  "20e338624cee": "Assets",
  "20fe4f42d7f8": "Nakaraang Buwan",
  "21808a71ead8": "Trend / Nangungunang Produkto",
  "21bc3ec9ecc6": "Kabuuang Customer",
  "226da5b84ad7": "Inventory Analytics",
  "22d5a3425998": "Magdagdag ng Animal",
  "2331907868e4": "Itala ang bayad mula sa Invoices tab—i-click ang “Magbayad” sa anumang unpaid invoice. Sinusuportahan ang cash, bangko, GCash, Maya, cheque, at mixed payment.",
  "24345a14377f": "Ngayon",
  "25bc96295797": "Analytics",
  "281119acb9e0": "Farm filter: Global",
  "28484e9d2642": "Ang mga hayop ay ibinebenta gamit ang parehong invoice ledger upang manatiling ganap na natutunton.",
  "285420aea9e2": "Trend ng Profit",
  "286daeb2a843": "Mga Benta completed through POS or invoices will appear here.",
  "29972f1aec9b": "unit na kailangang ibenta bawat buwan",
  "2a6590d41767": "Halaga Received",
  "2ab1c3e525b2": "Kabuuang Halaga (",
  "2b7336c8b9c9": "Reference / resibo #",
  "2bb6b986c5d6": "active",
  "2ee750e04190": "Tip:",
  "2f711885e0a7": "Contribution / Unit",
  "300cb1a029ad": ". To improve accuracy, assign employees to specific species (Admin → Employees), and tag inventory-movements with `species_id`.",
  "304f2a6def00": "Walang products match. Magdagdag ng some in Mga Benta & Inventory.",
  "30ad4167acea": "Natitira:",
  "30e4e2a86cc2": "Pumili payable",
  "317b1560fa04": "Mga Empleyadong Late",
  "318e2b4635fc": "Collections Buod",
  "31b956ddaa0e": "Benta ng Produkto",
  "32815b0bb690": "Gumawa ng Invoice",
  "32cf4b682e2b": "Executive View",
  "330450b7aa66": "Live na datos ng bukid",
  "33399e1e8956": "Income versus Mga Gastos",
  "33d7d03e71d4": "Panahon (YYYY-MM)",
  "3426de70a65a": "Mga Benta Today",
  "3551f3225c61": "Pagsusuri ng Break-Even",
  "35cf82f9d2a9": "Kita",
  "35f8f37b92ae": "Mga Invoice",
  "3609fc2d5fb5": "Kasalukuyang Stock",
  "36bff64e5d67": "Mga Disposal Ngayon",
  "3ba74080a591": "30-Day Revenue Trend",
  "3bcdd674f34e": "Ipadala sa Drive",
  "3c45b957fdc8": "Purchase Order",
  "3c8d8b817f47": "In:",
  "3deb74565196": "Type",
  "3e28eff6c2fc": "💡 Allocation:",
  "3e3d9cd36f9d": "Mga Bayad na Invoice",
  "3e8248e32edf": "Presyo",
  "3ed8fbe89a9e": "Walang executive data available yet.",
  "3f66052a107e": "Mula",
  "4053152f0642": "kabuuang babala",
  "42d21c02f4d3": "Mga Disposal",
  "43dc8532f7e5": "Halaga",
  "44357ae55a21": "Mga Bayad",
  "444fa32c06a7": "Gastos Categories",
  "44656820495b": "Cart",
  "44d25b5d1b6d": "Mga Item",
  "44f6af694554": "Dami",
  "4532461123e1": "Checkout at Magbayad",
  "4552eaf4d115": "Benta price",
  "4651a34e4df9": "Scope",
  "46cf37e16197": "O ilagay ang pangalan ng walk-in...",
  "474108de344b": "Mga bayad na invoice",
  "47cae30647fe": "Avg Benta Price",
  "47f8ae35eabf": "Walang receivables.",
  "49256255d0b0": "Walang payables.",
  "4a12196ff4e8": "Kita at Pagkalugi",
  "4ac296d5b2cc": "Bagong Product",
  "4af592953912": "Construction (napiling period)",
  "4b1f23f98e4f": "Benta Complete",
  "4b29c42c0d21": "Executive KPI Cards",
  "4c71073f929b": "active ·",
  "4d78e9f9edf0": "Daloy ng Cash",
  "4e68dca8ab90": "Ngayong Linggo",
  "4e896ec2eec4": "I-print ang Resibo",
  "4f327665da59": "Log Disposal / Allocation",
  "4fa71d634f54": "Manwal na Input",
  "4fee51fde270": "Pangalan ng Negosyo",
  "50cc12f69e8f": "Hindi Bayad",
  "51d8604430df": "Invoice #",
  "5301648dcf6b": "I-edit",
  "54376586d240": "Walk-in na customer",
  "5530e706d06b": "+ Med",
  "556a420333dd": "Liabilities",
  "55edd462872a": "Supplier",
  "55f8ebc805e6": "Paglalarawan",
  "560512c253ff": "Walang sales history",
  "5651124db206": "Dashboard ng Benta",
  "5674f7dce889": "Financial Analytics",
  "56e3badc4e6c": "I-refresh",
  "5801dd294561": "AI Dashboard Insight",
  "597f97a60987": "Balance Sheet",
  "59ef31e37acc": "Antas ng Reorder",
  "5a9469156270": "Nangungunang Produkto",
  "5ab37b321059": "I-save Supplier Payment",
  "5b0f7590d06f": "Nakolekta",
  "5b221e9c2a45": "I-print",
  "5c6505ae3c86": "TOTAL",
  "5e0d7363a956": "Customer:",
  "5f5a3fc65a12": "Inventory:",
  "5f612f65fc3f": "Maghanap products / animals",
  "5fa823f392c5": "Inaasahang Kapanganakan",
  "5fc7a471696c": "Hati ng Income",
  "6028a9a64574": "Presyo ng Gastos",
  "60d582bbb8cd": "Gastos Mix",
  "61ad50a9b918": "Target",
  "62c7fcf46e27": "Pagsusuri",
  "63c904559993": "Performance",
  "64fbd995d3b6": "Sukli",
  "650fe991ac42": "Kabuuang halaga",
  "6577ced3c078": "Itala ang Bayad",
  "659dba210997": "Pagsubaybay ng Bayad",
  "67dc05bac4fb": "Bagong Target",
  "6817176b8305": "Pumili customer",
  "689338b65b38": "Price per Unit (",
  "6a151d73d61b": "Kabuuang Paid",
  "6a2c211d3147": "Pangalan ng walk-in",
  "6a98e192a983": "Walang matching products",
  "6bdb25798a64": "Farm-Wide ·",
  "6c30d2615392": "rows",
  "6d6343ca92e0": "Pumili a species — we'll pull live feed, medicine, payroll, and sales data to compute its real break-even automatically.",
  "6ef8f5d65e5f": "Mga Bayad sa Supplier",
  "6f98cfd4f8fd": "Mga Benta Target",
  "700edaf90808": "Mga invoice na hindi pa bayad",
  "70440046a3dc": "Mga Tala",
  "706b2285196c": "Bayad sa Supplier",
  "709a23220f2c": "Pangalan",
  "717e1e93af99": "Del",
  "719ea396ad92": "I-clear",
  "71fe22635ffe": "ipakita ang parehong metrics para sa kasalukuyang buwan.",
  "728298d3dbf4": "Araw-araw",
  "728acc0ce486": "Walang targets yet. Click \"Bagong Target\" to set your first monthly goal.",
  "734a57d75218": "Could not load Mga Benta",
  "7389b3b752fa": "Animal",
  "739b6164d8f7": "Mga Overdue na Invoice",
  "748c323563fa": "Magbayad ngayon",
  "75636316f9d7": "Pangalan ng Customer",
  "768345f2ef09": "Magpatakbo ng ulat upang makita ang resulta.",
  "77064d526523": "Telepono",
  "776bc10edafc": "Itala ang Disposal",
  "77dfd2135f4d": "Kanselahin",
  "78c072709400": "Cashier",
  "7a20bf140d9c": "Mabilisang Pagbabayad",
  "7aab10488c30": "Mas mataas ay mas mabuti",
  "7bb2ee60f7c8": "Aktwal",
  "7c62a1424469": "Available",
  "7d87e329b6f5": "Available na Credit",
  "7da80f376d4f": "Walang invoices yet.",
  "7e505191686b": "Revenue kumpara sa kabuuang gastos ng mga unit na nabenta",
  "7ed9b8236e54": "Mga Babala at Paalala",
  "7f8966640d8f": "Target na Units",
  "7f9047479da7": "Margin:",
  "801d866beb88": "Walk-in",
  "80c37573afed": "Magbayad",
  "8159bd4e7e98": "Maghanap customers...",
  "824b30eb3d6f": "nabenta ngayong buwan",
  "8324113fd693": "Attendance Buod",
  "83a7238826ab": "Species",
  "83c81d7a5d24": "Walang laman ang cart. Pindutin ang produkto upang magdagdag.",
  "8434c52b54f0": "Tatanggap",
  "84add5b29527": "Email",
  "8598222918d3": "Select",
  "85bfb2b6f8f1": "Benta ng hayop at produkto, invoice, resibo, customer database, payment tracking, at kasaysayan ng benta.",
  "85c2702ad781": "Mga Benta & Inventory",
  "865c087f16fa": "Mga Paggamot na Due",
  "869bd1fe0a00": "Mga Item na Mababang Stock",
  "86b6e9c44c38": "Ilagay ang presyo ng hayop",
  "878bae99dd28": "Bagong Invoice",
  "88306943fea7": "Paraan",
  "8870388c7105": "Mga Benta Desk",
  "88a006abc361": "Walang products yet. Magdagdag ng your first!",
  "88bc3fe3dadd": "Mga Ulat",
  "88f98b3800dc": "Trend ng Konsumo ng Pakain",
  "8a45d339a638": "Credit",
  "8ab4a4daf337": "Walang supplier payments.",
  "8bebc63cc939": "Net Profit",
  "8c34947365c3": "Walang customer sales yet",
  "8d437dbf95ab": "Mga Gastos",
  "8da7a1d95a5f": "Mga Gawain at Paalala",
  "8dce170de238": "Halaga",
  "8e104572372b": "Mga Dapat Bayaran",
  "8e5903a8e4db": "Kalkulahin",
  "8faf93a978fd": "CAPEX (Month)",
  "90eef613042c": "Balanse",
  "9150bcc33369": "Animal Mga Benta",
  "917625318331": "units",
  "927273a84696": "Mga Invoice Ngayong Buwan",
  "92cd1375d5cf": "Gamitin ang Aktwal",
  "92f24dfdc1ba": "Halaga ng Nasira",
  "93206d9bd672": "Walang disposals logged yet.",
  "9387477796af": "Live na livestock",
  "93b2cc26caff": "Walang customers yet. Magdagdag ng your first!",
  "949bac1aa62e": "Benta sa Buwan",
  "94efd3f5de9c": "Buod ng Bukid",
  "9644346d2301": "Mga Benta Trend",
  "96d034d0e103": "I-save Disposal",
  "97f7359ed801": "Subtotal",
  "985cefcf2186": "Trend ng Pagkamatay",
  "98635e8c6343": "Naglo-load sales workspace...",
  "98e5ef062b2a": "I-download ang PDF",
  "9988442239f1": "Naglo-load executive dashboard...",
  "998955fd9442": "Retail Net Profit",
  "9a4e89db46e7": "of farm · Panahon",
  "9b00e5c1e298": "Awtomatikong Profitability Bawat Species",
  "9be70f66f8dd": "Buwis",
  "9cc8dedc2b90": "Stock ng Pakain at Gamot",
  "9e9477eabd86": "Absent Ngayon",
  "9f5cd8a2e880": "Subukan Muli",
  "a00475b4d631": "Preview ng Resibo",
  "a08e11119aef": "Excel",
  "a0db8e68b834": "Gastos",
  "a16f1a3eb266": "Cash at Bangko:",
  "a1b26b4530ec": "Target na Profit (opsyonal)",
  "a1b308ec704a": "Takdang Petsa",
  "a1fdaa6b2a84": "Mga Operasyon",
  "a25ca5d39a61": "Benta Ngayon",
  "a2db98ef530b": "Halaga ng Imbentaryo",
  "a2e5076fdbe4": "Pinakamagandang Araw ng Linggo",
  "a345f2e5b6e6": "AJ'S FARM · COMMAND CENTER",
  "a3c686e711e4": "Kategorya",
  "a438f6b92752": "Variable Cost / Unit",
  "a4a52407a5c6": "I-download / I-print ang PDF",
  "a666b9243f26": "Ulat Type",
  "a72ca256dc49": "Statement",
  "a965c5d733ce": "Bayad na:",
  "a9f3f5b0b784": "Aktwal na Revenue (Buwan)",
  "aa389b318ef8": "Kasalukuyang period:",
  "ad68e79c9015": "Mga Paraan ng Pagbabayad",
  "ae1899ecfd17": "Subcategory",
  "ae61346ab23e": "Pumili ng species...",
  "ae65324b857d": "Farm Operations",
  "ae79ea1e9c63": "To",
  "af5c4843442e": "Mga Overdue na Gawain",
  "b04ba49f8486": "Naglo-load...",
  "b0730eec432f": "Walang customer payments.",
  "b0bc4d15fe08": "Buong Bukid",
  "b0dd615cbbdc": "Mga Contact",
  "b1a3b1aee034": "Mga Unit na Nabenta",
  "b1ffeaea78c8": "Magandang umaga,",
  "b25928c69902": "Kabuuan",
  "b28a7d69c448": "Log ng Disposal / Allocation",
  "b298bc6a9e73": "Mga Bakunang Due",
  "b32f279e548b": "each",
  "b524936d7aa1": "Discount",
  "b5674a023931": "Filter ng lokasyon:",
  "b58398a70de3": "Buod ng Bukid",
  "b692be478a94": "Walang customer records",
  "b6c600062323": "Mga Nangungunang Customer",
  "b8bcab1c909b": "Lampas sa Credit Limit",
  "b93abe4c560c": "Mga Benta Analytics",
  "b956fe74ee95": "Inventory Movement Buod",
  "baca91664986": "Live na imbentaryo",
  "bae7d5be7082": "Katayuan",
  "bba03798749d": "Mga Bahagyang Bayad na Invoice",
  "bbfa773e5a63": "Isara",
  "bcecf4562f17": "Stock",
  "bd7d7de86af6": "Mga Hayop na Handa nang Ibenta",
  "bd91f0161b70": "Pananalapi",
  "be6ffb598e6a": "Pumili eligible animal",
  "bfa0df1d1c50": "Pamahalaan →",
  "bfa4d6fa106b": "Animal Benta",
  "bfe0a80d77d5": "Subaybayan ang credit limit, hindi pa bayad na balance, at account statement.",
  "c0b84858c247": "Cashier Leaderboard",
  "c1934178ea75": "I-save Scenario",
  "c201cc5e25b6": "Statement —",
  "c2f1302a0a50": "Credit Limit",
  "c2f9c4fd53fb": "Credit Limit (",
  "c3e815afba60": "invoices",
  "c677df573f74": "Magdagdag ng Animal Benta",
  "c7b6a95036d3": "MoM Growth",
  "c89dd33c646c": "Ref",
  "c8e4fecc6486": "Magdagdag ng products or animals to create an invoice.",
  "c92c0c39c1e8": "Magdagdag ng Customer",
  "cad804aedb53": "Mga Dapat Singilin",
  "cae905d7914f": "Mga Benta History",
  "cba7e62fc003": "Pangalan, SKU, tag, species...",
  "cce0c146af66": "Gamot na Malapit Mag-expire",
  "cd24f58f2ae4": "Mga Tala / Item",
  "ce85fb7cc24b": "Animals by Katayuan",
  "cf558941e04e": "Debit",
  "cfc68d1ba331": "Bagong Transaction",
  "cfc77c0c1b1f": "Kamakailang Galaw ng Stock",
  "cffa50a32cb1": "and",
  "d0edfb6e8c55": "Mga Benta",
  "d145bb830936": "Pangalan *",
  "d1f0809a0d18": "Op. Profit",
  "d2faabf68a9f": "Kabuuang Billed",
  "d31edb7b8a94": "Buwanan",
  "d3ac55072811": "Mga Target sa Benta",
  "d3d362b505e9": "Pangalan...",
  "d45987441aa0": "Payroll",
  "d481afbb2502": "Income vs Gastos Trend",
  "d48f53aaa4da": "Walang payments yet",
  "d558761bed9b": "Maghanap ayon sa pangalan ng produkto o SKU.",
  "d59192b9c8f2": "SKU",
  "d5a5e547a728": "Kabuuang Collected",
  "d613d88cb2d8": "PDF",
  "d622ac995de6": "Mga produkto, invoice, bayad, at disposal—lahat sa iisang lugar.",
  "d63af7f176b1": "Bahagi ng Fixed Cost",
  "d7020f448aaf": "Mga Puna",
  "d70f93df5e8f": "Address",
  "d87f47b47e4d": "Dashboard",
  "d8e7170f94e7": "Total:",
  "d96f52b84799": "Halaga ng Imbentaryo",
  "da33e1b7e0c4": "Construction",
  "db1c784524e1": "Reference",
  "dc9d4584a554": "Bayad",
  "dd3b86d1ef21": "Produkto",
  "dda2313a7779": "Accounts Receivable:",
  "de556948132e": "Mga Naka-save na Scenario",
  "debd497b31c2": "Hindi pa Nakokolektang A/R",
  "e17c8ad0dc2e": "Refund",
  "e2234e0631a8": "· stock",
  "e26102ea8e0e": "Halaga to Pay",
  "e300af6aa1ab": "Mga Aktibong Customer",
  "e32ed0097417": "Narito ang nangyayari sa iyong bukid ngayon.",
  "e34523b36c1d": "Naglo-load executive analytics...",
  "e38c3c26615c": "Mga Invoice Ngayon",
  "e3ea0776251e": "Mabilis na checkout—pumili ng produkto, tumanggap ng bayad, at mag-print ng resibo.",
  "e3f5f6946da2": "Maghanap ng produkto o SKU...",
  "e46c6a339995": "Tatanggap / Customer",
  "e6d551b7005d": "Database ng Customer",
  "e7122e2a7891": "CAPEX",
  "e765a0a52295": "Bawat Species",
  "e77284395aa6": "/sales-dashboard",
  "e7fee63fe608": "Kategorya Mix (Month)",
  "e83c8a8ffdc9": "Revenue na natitira bawat unit pagkatapos ng variable cost",
  "eb6360a6e8b7": "Attendance at Payroll",
  "eb9a4bc1c0c1": "Petsa",
  "ec8a638c20f0": "Cart (",
  "efc007a393f6": "I-save",
  "f07ca04bdec7": "Walang laman ang cart",
  "f1a20bd22739": "Create customers from the Mga Customer page to track balances here.",
  "f1fbb2b43dca": "Preview",
  "f219cc0614ae": "Dahilan",
  "f2302c88a11a": "Invoice Only",
  "f292b8081d8b": "Karaniwang halaga ng order",
  "f2a3f161d5b6": "Walang sales yet",
  "f383f6a23c87": "Paraan ng Pagbabayad",
  "f41107c4fcd2": "Lahat ng Target",
  "f52767eee809": "Huling update:",
  "f5f032b11074": "/overview",
  "f6638aaa02f9": "- due",
  "f67c40299562": "Benta ng Hayop",
  "f6b935ab3371": "Unit",
  "f6fdbe48dc54": "Tanggalin",
  "f794b6c6d153": "Walang transactions yet.",
  "f7af89907cdc": "Break-Even Revenue",
  "f7c40075b47e": "Contribution Margin",
  "f81e6e6edd64": "Mga Hindi Bayad na Invoice",
  "f834ab20b880": "Top 10 Produkto (Revenue Ngayong Buwan)",
  "f871a067ec7e": "10kg pork @ ₱250, 5kg tilapia @ ₱180...",
  "f8ee57ec8645": "Hindi pa Bayad",
  "f9c30b15af01": "Break-Even Units",
  "f9e6fe6b07f8": "Trend ng Timbang",
  "f9f38818c406": "Invoice",
  "fa3cf2ad51e0": "Magbenta",
  "fccd53375cbe": "Payroll na Dapat Bayaran:",
  "fe0a091fdbfb": "Mga Produkto",
  "fe5505baf6c5": "Fixed Costs / mo (",
  "fef503a9816e": "Mga Naitalang Bayad",
  "ff1928e5d29b": "Feed"
};
